module.exports = __webpack_public_path__ + "img/joker_600.d81e9cd8.png";